export const GET_EXPENSE = "GET_EXPENSE";
export const ADD_EXPENSE = "ADD_EXPENSE";
export const UPDATE_EXPENSE = "UPDATE_EXPENSE";
export const DELETE_EXPENSE = "DELETE_EXPENSE";
export const INCREMENT_PAGE = "INCREMENT_PAGE";
export const CLEAR_EXPENSE = "CLEAR_EXPENSE";
export const TOTAL_EXPENSE = "TOTAL_EXPENSE";


